"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebBridgeApi = exports.setDevelopmentMode = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _define = require("./define");

var _state = require("./state");

var _native = require("./native");

require("./interface");

var _R = function _R(result) {
  (0, _state.__log)('result is', result);
  return {
    err: '',
    result: result
  };
};

var _BetaData = {
  pic: 'http://pic136.nipic.com/file/20170725/10673188_152559977000_2.jpg',
  video: 'http://pic136.nipic.com/file/20170725/10673188_152559977000_2.mp4'
};
/**
 * 设置开发模式
 */

var setDevelopmentMode = function setDevelopmentMode(isDev) {
  (0, _state.__set_mode)(isDev ? _define.BridgeMode.Development : _define.BridgeMode.Production);
};
/**
 * 桥接口
 */


exports.setDevelopmentMode = setDevelopmentMode;
var WebBridgeApi = {
  /**
   * 请求
   */
  requireVersion: function requireVersion(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.requireVersion, input);

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
              return _context.abrupt("return", input);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * 系统信息
   */
  sysinfo: function sysinfo() {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.sysinfo, {});

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 4:
              (0, _state.__log)('sysinfo dev');
              return _context2.abrupt("return", _R({
                Brand: "品牌",
                SystemName: "系统名称",
                SystemVersion: "系统版本",
                BundleId: "报名",
                ApplicationName: "APP名称",
                BuildNumber: "编译版本",
                Version: "版本",
                ReadableVersion: "完整版本",
                DeviceName: "设备名称",
                UserAgent: "Agent",
                Carrier: "运营商",
                NetInfo: "网络环境",
                Config: {}
              }));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * 扫描二维码
   * @param {*} input
   */
  scanCode: function scanCode(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context3.next = 4;
                break;
              }

              _context3.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.scanCode, input);

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 4:
              return _context3.abrupt("return", _R('' + new Date().valueOf()));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * 请求授权
   */
  authorize: function authorize(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee4() {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context4.next = 4;
                break;
              }

              _context4.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.authorize, input);

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 4:
              return _context4.abrupt("return", _R({
                avatar: _BetaData.pic,
                islock: "0",
                isslient: "0",
                nickname: "昵称",
                phone: "13000000000",
                token: "yuUeDo5kaomEebwgnkJZWdNg33XU+ZT2a6KhDLfvdDEV/HoW/v/TBXa1WbK1yc0q"
              }));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * 获取当前登录用户信息
   */
  getUserInfo: function getUserInfo(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee5() {
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context5.next = 4;
                break;
              }

              _context5.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.getUserInfo, input);

            case 3:
              return _context5.abrupt("return", _context5.sent);

            case 4:
              return _context5.abrupt("return", _R({
                avatar: _BetaData.pic,
                islock: "0",
                isslient: "0",
                nickname: "昵称",
                phone: "13000000000",
                token: "yuUeDo5kaomEebwgnkJZWdNg33XU+ZT2a6KhDLfvdDEV/HoW/v/TBXa1WbK1yc0q"
              }));

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * 网络请求
   * @param {*} input
   */
  fetch: function fetch(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee6() {
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context6.next = 4;
                break;
              }

              _context6.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.fetch, input);

            case 3:
              return _context6.abrupt("return", _context6.sent);

            case 4:
              return _context6.abrupt("return", _R({
                header: {},
                body: 'hello world'
              }));

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },

  /**
   * 打开路由
   * @param {*} RouterInput
   */
  router: function router(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee7() {
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context7.next = 4;
                break;
              }

              _context7.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.router, input);

            case 3:
              return _context7.abrupt("return", _context7.sent);

            case 4:
              return _context7.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },

  /**
   * 打开支持桥的web页面
   * @param {} WebAppInput
   */
  showWebApp: function showWebApp(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee8() {
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context8.next = 4;
                break;
              }

              _context8.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.showWebApp, input);

            case 3:
              return _context8.abrupt("return", _context8.sent);

            case 4:
              return _context8.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },

  /**
   * toast
   * @param {*} ToastInput
   */
  showToast: function showToast(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee9() {
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context9.next = 4;
                break;
              }

              _context9.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.showToast, input);

            case 3:
              return _context9.abrupt("return", _context9.sent);

            case 4:
              return _context9.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },

  /**
   * 弹出对话框
   * @param {*} DialogInput
   * @type {Number}
   */
  showDialog: function showDialog(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee10() {
      return _regenerator["default"].wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context10.next = 4;
                break;
              }

              _context10.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.showDialog, input);

            case 3:
              return _context10.abrupt("return", _context10.sent);

            case 4:
              return _context10.abrupt("return", _R(1));

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },

  /**
   * 选择图片
   * @param input 
   * @type {Promise<ResultObject>}
   */
  chooseImage: function chooseImage(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee11() {
      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context11.next = 4;
                break;
              }

              _context11.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.chooseImage, input);

            case 3:
              return _context11.abrupt("return", _context11.sent);

            case 4:
              return _context11.abrupt("return", _R(_BetaData.pic));

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))();
  },

  /**
   * 选择视频
   * @param input 
   * @type {Promise<ResultObject>}
   */
  chooseVideo: function chooseVideo(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee12() {
      return _regenerator["default"].wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context12.next = 4;
                break;
              }

              _context12.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.chooseVideo, input);

            case 3:
              return _context12.abrupt("return", _context12.sent);

            case 4:
              return _context12.abrupt("return", _R(_BetaData.video));

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }))();
  },

  /**
   * 预览大图
   * @param input ViewImage[]
   * @type {Promise<ResultObject>}
   */
  showImageViewer: function showImageViewer(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee13() {
      return _regenerator["default"].wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context13.next = 4;
                break;
              }

              _context13.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.showImageViewer, input);

            case 3:
              return _context13.abrupt("return", _context13.sent);

            case 4:
              return _context13.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }))();
  },

  /**
   * 播放全屏视频
   * @param input 
   */
  showFullVideoPlayer: function showFullVideoPlayer(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee14() {
      return _regenerator["default"].wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context14.next = 4;
                break;
              }

              _context14.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.showFullVideoPlayer, input);

            case 3:
              return _context14.abrupt("return", _context14.sent);

            case 4:
              return _context14.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }))();
  },

  /**
   * 请求全屏 注：此接口是webview界面特有接口
   * @param input 
   */
  requestFullscreenVideoPlay: function requestFullscreenVideoPlay(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee15() {
      return _regenerator["default"].wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context15.next = 4;
                break;
              }

              _context15.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.requestFullscreenVideoPlay, input);

            case 3:
              return _context15.abrupt("return", _context15.sent);

            case 4:
              return _context15.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }))();
  },

  /**
  * 请求权限
  * @param input 
  */
  checkPermission: function checkPermission(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee16() {
      return _regenerator["default"].wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context16.next = 4;
                break;
              }

              _context16.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.checkPermission, input);

            case 3:
              return _context16.abrupt("return", _context16.sent);

            case 4:
              return _context16.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }))();
  },

  /**
   * 录制麦克风声音
   * @param input 
   */
  audioRecord: function audioRecord(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee17() {
      return _regenerator["default"].wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context17.next = 4;
                break;
              }

              _context17.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.audioRecord, input);

            case 3:
              return _context17.abrupt("return", _context17.sent);

            case 4:
              return _context17.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }))();
  },

  /**
   * 分享
   * @param input 
   */
  share: function share(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee18() {
      return _regenerator["default"].wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context18.next = 4;
                break;
              }

              _context18.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.share, input);

            case 3:
              return _context18.abrupt("return", _context18.sent);

            case 4:
              return _context18.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }))();
  },

  /**
   * 分享
   * @param input 
   */
  openLink: function openLink(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee19() {
      return _regenerator["default"].wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context19.next = 4;
                break;
              }

              _context19.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.openLink, input);

            case 3:
              return _context19.abrupt("return", _context19.sent);

            case 4:
              return _context19.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }))();
  },

  /**
   * 显示Picker菜单
   * @param input 
   */
  showPickerMenu: function showPickerMenu(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee20() {
      return _regenerator["default"].wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context20.next = 4;
                break;
              }

              _context20.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.showPickerMenu, input);

            case 3:
              return _context20.abrupt("return", _context20.sent);

            case 4:
              return _context20.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }))();
  },

  /**
   * 启动微信小程序
   * @param input 
   */
  launchWechatProgram: function launchWechatProgram(input) {
    return (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee21() {
      return _regenerator["default"].wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              if (!((0, _state.__get_mode)() == _define.BridgeMode.Production)) {
                _context21.next = 4;
                break;
              }

              _context21.next = 3;
              return (0, _native.__request)(_define.WebBridgeApiConstants.launchWechatProgram, input);

            case 3:
              return _context21.abrupt("return", _context21.sent);

            case 4:
              return _context21.abrupt("return", _R(true));

            case 5:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }))();
  }
}; // if ((<any>window)) {
//   (<any>window).WebBridgeApi = WebBridgeApi;
//   (<any>window).alert('loadded');
// }

exports.WebBridgeApi = WebBridgeApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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